import React, { useEffect } from "react";
import Hero from "../../components/retirement-planning/Hero";
import HowFintooHelps from "../../components/retirement-planning/HowFintoo";
import WhyRetirementPlanning from "../../components/retirement-planning/WhyRetirementPlanning";
import Testimonials from "../../components/retirement-planning/testimonials";
import FinalCTA from "../../components/retirement-planning/FinalCta";
import Disclaimer from "../../components/retirement-planning/Disclaimer";

export default function RetirementPlanningNew() {

  return (
    <>
      <Hero />
      <HowFintooHelps />
      <WhyRetirementPlanning />
      <Testimonials />
      <FinalCTA />
      <Disclaimer />
    </>
  );
}
